import merge from "lodash/merge";
import { UploaderFlowProvider } from "./provider/uploaderFlowProvider";
import { UploaderFlowProps } from "./hooks/useUploaderFlow";
import { defaultAddonRegistry, UploaderFlow } from "./UploaderFlow";
import { AddonConstructor, IAddonRegistry } from "./addons/AddonRegistry";
import { AddonsManagerProvider } from "./addons/providers/AddonsManagerProvider";

interface EnhancedUploaderProps<T extends string> extends UploaderFlowProps<T> {
  addons?: AddonConstructor[];
  addonRegistry?: IAddonRegistry;
}

const defaultUploaderFlowProps: Partial<UploaderFlowProps<any>> = {
  dateFormat: "yyyy-mm-dd",
  uploadStepHook: async data => {
    return data;
  },
  selectHeaderStepHook: async (hData, data) => {
    return {
      headerValues: hData,
      data
    };
  },
  matchColumnsStepHook: async data => {
    return data;
  },
  parseRaw: true,
  addons: [],
  addonRegistry: defaultAddonRegistry
};

export const Uploader = <T extends string>(propsWithoutDefaults: EnhancedUploaderProps<T>) => {
  const props = merge({}, defaultUploaderFlowProps, propsWithoutDefaults);

  return (
    <UploaderFlowProvider uploaderFlowValues={{ ...props }}>
      <AddonsManagerProvider
        onSubmit={props.onSubmit}
        onStepChangeHook={props.onStepChangeHook}
        onStepSelectHook={props.onStepSelectHook}
      >
        <UploaderFlow></UploaderFlow>
      </AddonsManagerProvider>
    </UploaderFlowProvider>
  );
};
